import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/goalsSagas";
import { getGoalsHeaderConfig } from "../headerConfigs/headerConfigs";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import GoalsList from "../../../components/goalsListNew/goalsList";
import { AddStaff } from "./AddStaff";

const GoalSection = ({ goalType, defaultTitle, zIndex }) => {
  const dispatch = useDispatch();
  const singleLocation = useSelector((state) => state.newGoals.currentUser.singleLocation);
  const selectedModuleView = useSelector((state) => state.newGoals.selectedModuleView.id);
  const goalsLoading = useSelector((state) => state.newGoals.goalsLoading[goalType]);
  const visibleColumns = useSelector((state) => state.newGoals.visibleColumns);
  const selectedView = useSelector((state) => state.newGoals.selectedView.id);
  const goalsData = useSelector((state) => state.newGoals.goals);
  const date = useSelector((state) => state.newGoals.date);

  const title = goalsData[`${goalType}Title`] || defaultTitle;
  const goals = goalsData[goalType] || [];

  const goalsHeaderConfig = useMemo(
    () =>
      getGoalsHeaderConfig({ visibleColumns, selectedView, singleLocation, selectedModuleView }),
    [visibleColumns]
  );

  if (!goals.length && !visibleColumns.showAddStaffButton) return null;
  return (
    <div style={{ marginTop: "7px" }}>
      <SectionToggle
        title={title}
        isLoading={goalsLoading}
        customClass={`${goalType}Goals`}
        autoHeight
        content={
          <GoalsList
            isAnimated={false}
            title={title}
            goalsHeaderContent={
              visibleColumns.showAddStaffButton && (() => <AddStaff goalType={goalType} />)
            }
            goalData={goals}
            zIndex={zIndex}
            goalsHeaderConfig={goalsHeaderConfig}
            date={date}
            visibleColumns={visibleColumns}
            singleLocation={singleLocation}
            moduleView={selectedModuleView}
            selectedView={selectedView}
            saveGoal={(id, value, active, goal_store_id) =>
              dispatch(
                actionCreators.updateGoal({
                  id: id,
                  value: value,
                  active: active,
                  goal_type: goalType,
                  goal_store_id
                })
              )
            }
            saveGoalAsValue={(id, value, active, goal_store_id) =>
              dispatch(
                actionCreators.updateGoalAsValue({
                  id: id,
                  value: value || 0,
                  active: active,
                  goal_type: goalType,
                  goal_store_id
                })
              )
            }
          />
        }
      />
    </div>
  );
};

export default GoalSection;
